import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import RedirectBackButton from "components/RedirectBackButton";
import RowElement from "components/RowElement";
import useGlobalContext from "hooks/globalData";
import useTitle from "hooks/useTitle";
import { FormattedMessage as T, useIntl } from "react-intl";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import {
  ResponseOfSkuAvailability,
  ResponseOfSkuFormat,
  ResponseOfSkus,
} from "services/KnowfullyAdminClient";
import SkuRegistrationsList from "./SkuRegistrationsList";

const SkuRegistrations = () => {
  const { formatMessage: t } = useIntl();
  const { id: skuId } = useParams<{ id: string }>();
  const { skuService, skuDetailsUrl } = useGlobalContext();

  const skuResult = useQuery<ResponseOfSkus>(
    ["skuById", skuId],
    () => skuService.getSkuById(skuId!),
    {
      enabled: !!skuId,
    }
  );

  const skuObject = skuResult.data?.data;
  useTitle(t({ id: "courseRegistrationsTitle" }, { sku: skuObject?.sku }));

  const {
    data: skuFormatData,
    isLoading: isLoadingSkuFormat,
  } = useQuery<ResponseOfSkuFormat>(
    ["skuFormat", skuId],
    () => skuService.getSkuFormatById(skuObject?.skuFormatId!),
    { enabled: !!skuId && !!skuObject && !!skuObject.skuFormatId }
  );

  const {
    data: skuAvailabilityData,
    isLoading: isLoadingSkuAvailability,
  } = useQuery<ResponseOfSkuAvailability>(
    ["skuAvailability", skuId],
    () => skuService.getSkuAvailabilityById(skuObject?.skuAvailabilityId!),
    { enabled: !!skuId && !!skuObject && !!skuObject.skuAvailabilityId }
  );

  const rows = [
    RowElement("courseLabel", skuObject?.title ?? "", skuResult.isLoading),
    RowElement("skuLabel", skuObject?.sku ?? "", skuResult.isLoading),
    RowElement(
      "skuAvailabilityLabel",
      skuAvailabilityData?.data?.name ?? "",
      isLoadingSkuAvailability
    ),
    RowElement(
      "skuFormatLabel",
      skuFormatData?.data?.name ?? "",
      isLoadingSkuFormat
    ),
  ].filter((r) => !!r.component);

  return (
    <>
      <RedirectBackButton
        redirectRoute={skuDetailsUrl(skuId)}
        labelKey="backToSkuButtonLabel"
      />

      <h1>
        <T id="courseRegistrations" />
      </h1>

      <Box mb={4}>
        <TableContainer component={Paper}>
          <Table>
            <TableBody>
              {rows.map(({ title, component }, i) => (
                <TableRow key={title}>
                  <TableCell component="th" scope="row">
                    {title}
                  </TableCell>
                  <TableCell>{component}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      <SkuRegistrationsList skuId={skuId!} />
    </>
  );
};

export default SkuRegistrations;
